import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const PasswordUpdated: React.FC<IconProps> = () => {
  return (
    <svg width="150" height="154" viewBox="0 0 150 154" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M75 150.65C116.421 150.65 150 117.072 150 75.6504C150 34.229 116.421 0.650391 75 0.650391C33.5786 0.650391 0 34.229 0 75.6504C0 117.072 33.5786 150.65 75 150.65Z"
        fill="#EAECF0"
      />
      <g filter="url(#filter0_d_9576_33189)">
        <mask id="mask0_9576_33189" maskUnits="userSpaceOnUse" x="0" y="0" width="150" height="151">
          <path
            d="M75 150.65C116.421 150.65 150 117.072 150 75.6504C150 34.229 116.421 0.650391 75 0.650391C33.5786 0.650391 0 34.229 0 75.6504C0 117.072 33.5786 150.65 75 150.65Z"
            fill="url(#paint0_linear_9576_33189)"
          />
        </mask>
        <g mask="url(#mask0_9576_33189)">
          <path
            d="M118 43.6504H32C29.2386 43.6504 27 45.889 27 48.6504V153.65C27 156.412 29.2386 158.65 32 158.65H118C120.761 158.65 123 156.412 123 153.65V48.6504C123 45.889 120.761 43.6504 118 43.6504Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M66 53.6504H40C38.3431 53.6504 37 54.9935 37 56.6504C37 58.3072 38.3431 59.6504 40 59.6504H66C67.6569 59.6504 69 58.3072 69 56.6504C69 54.9935 67.6569 53.6504 66 53.6504Z"
        fill="#EAECF0"
      />
      <path
        d="M78.6269 95.6318H41.2638C38.8828 95.6318 36.9526 96.9799 36.9526 98.6428C36.9526 100.306 38.8828 101.654 41.2638 101.654H78.6269C81.0079 101.654 82.938 100.306 82.938 98.6428C82.938 96.9799 81.0079 95.6318 78.6269 95.6318Z"
        fill="#EAECF0"
      />
      <path
        d="M108 68.6504H41.9995C39.7904 68.6504 37.9995 70.4413 37.9995 72.6504V82.6504C37.9995 84.8595 39.7904 86.6504 41.9995 86.6504H108C110.209 86.6504 112 84.8595 112 82.6504V72.6504C112 70.4413 110.209 68.6504 108 68.6504Z"
        stroke="#98A2B3"
      />
      <path
        d="M51.0625 81.3408H52.668L52.5391 78.3525L55.0117 79.9111L55.8086 78.6689L53.0898 77.2275L55.8086 75.7979L55.0117 74.5557L52.5391 76.1143L52.668 73.126H51.0625L51.1914 76.126L48.707 74.5557L47.9102 75.7979L50.6289 77.2275L47.9102 78.6689L48.707 79.9111L51.1914 78.3408L51.0625 81.3408ZM62.3828 81.3408H63.9883L63.8594 78.3525L66.332 79.9111L67.1289 78.6689L64.4102 77.2275L67.1289 75.7979L66.332 74.5557L63.8594 76.1143L63.9883 73.126H62.3828L62.5117 76.126L60.0273 74.5557L59.2305 75.7979L61.9492 77.2275L59.2305 78.6689L60.0273 79.9111L62.5117 78.3408L62.3828 81.3408ZM73.7031 81.3408H75.3086L75.1797 78.3525L77.6523 79.9111L78.4492 78.6689L75.7305 77.2275L78.4492 75.7979L77.6523 74.5557L75.1797 76.1143L75.3086 73.126H73.7031L73.832 76.126L71.3477 74.5557L70.5508 75.7979L73.2695 77.2275L70.5508 78.6689L71.3477 79.9111L73.832 78.3408L73.7031 81.3408ZM85.0234 81.3408H86.6289L86.5 78.3525L88.9727 79.9111L89.7695 78.6689L87.0508 77.2275L89.7695 75.7979L88.9727 74.5557L86.5 76.1143L86.6289 73.126H85.0234L85.1523 76.126L82.668 74.5557L81.8711 75.7979L84.5898 77.2275L81.8711 78.6689L82.668 79.9111L85.1523 78.3408L85.0234 81.3408ZM96.3438 81.3408H97.9492L97.8203 78.3525L100.293 79.9111L101.09 78.6689L98.3711 77.2275L101.09 75.7979L100.293 74.5557L97.8203 76.1143L97.9492 73.126H96.3438L96.4727 76.126L93.9883 74.5557L93.1914 75.7979L95.9102 77.2275L93.1914 78.6689L93.9883 79.9111L96.4727 78.3408L96.3438 81.3408Z"
        fill="#98A2B3"
      />
      <path
        d="M108 109.65H42C39.2386 109.65 37 111.889 37 114.65V122.65C37 125.412 39.2386 127.65 42 127.65H108C110.761 127.65 113 125.412 113 122.65V114.65C113 111.889 110.761 109.65 108 109.65Z"
        fill="#98A2B3"
      />
      <path
        d="M53 32.6504C55.2091 32.6504 57 30.8595 57 28.6504C57 26.4413 55.2091 24.6504 53 24.6504C50.7909 24.6504 49 26.4413 49 28.6504C49 30.8595 50.7909 32.6504 53 32.6504Z"
        fill="white"
      />
      <path
        d="M75 32.6504C77.2091 32.6504 79 30.8595 79 28.6504C79 26.4413 77.2091 24.6504 75 24.6504C72.7909 24.6504 71 26.4413 71 28.6504C71 30.8595 72.7909 32.6504 75 32.6504Z"
        fill="#98A2B3"
      />
      <path
        d="M97 32.6504C99.2091 32.6504 101 30.8595 101 28.6504C101 26.4413 99.2091 24.6504 97 24.6504C94.7909 24.6504 93 26.4413 93 28.6504C93 30.8595 94.7909 32.6504 97 32.6504Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.734 62.5706C119.754 62.5706 122.65 61.3709 124.785 59.2355C126.921 57.1 128.12 54.2037 128.12 51.1837C128.12 48.1638 126.921 45.2675 124.785 43.132C122.65 40.9966 119.754 39.7969 116.734 39.7969C113.714 39.7969 110.817 40.9966 108.682 43.132C106.546 45.2675 105.347 48.1638 105.347 51.1837C105.347 54.2037 106.546 57.1 108.682 59.2355C110.817 61.3709 113.714 62.5706 116.734 62.5706ZM122.01 49.3433C122.269 49.0749 122.413 48.7153 122.409 48.3421C122.406 47.9689 122.256 47.6119 121.993 47.348C121.729 47.0841 121.372 46.9345 120.998 46.9312C120.625 46.928 120.266 47.0714 119.997 47.3307L115.31 52.0178L113.47 50.1774C113.201 49.9181 112.842 49.7747 112.469 49.7779C112.095 49.7812 111.738 49.9309 111.474 50.1948C111.211 50.4587 111.061 50.8157 111.058 51.1889C111.054 51.5621 111.198 51.9216 111.457 52.19L114.304 55.0368C114.571 55.3036 114.933 55.4535 115.31 55.4535C115.688 55.4535 116.05 55.3036 116.316 55.0368L122.01 49.3433Z"
        fill="#98A2B3"
      />
      <defs>
        <filter id="filter0_d_9576_33189" x="21" y="34.6504" width="108" height="119" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9576_33189" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9576_33189" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_9576_33189" x1="75" y1="0.650391" x2="75" y2="150.65" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E3ECFA" />
          <stop offset="1" stopColor="#DAE7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PasswordUpdated;
